import type { AppRegistryPage } from '@plato/app-meta/ai-meta';
import { usePageAiMeta } from '@plato/app-shared/hooks/use-page-ai-meta';
import { SrSalesOrderType } from '@plato/data/starrocks/types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useTransactionDetailLineItemsColumns } from '../../../features/list-views/columns/use-transaction-detail-line-items-columns.tsx';
import { useQuoteOrderAttachmentsColumns } from '../../../features/quote-order-detail/components/quote-order-attachments-tab.tsx';
import { QuoteOrderDetailPage } from '../../../features/quote-order-detail/pages/quote-order-detail-page.tsx';

export function useQuoteDetailAiMeta(): AppRegistryPage {
    const { t } = useTranslation();
    const attachmentColumns = useQuoteOrderAttachmentsColumns();
    const lineItemColumns = useTransactionDetailLineItemsColumns({});
    const columns = useMemo(
        () => [...attachmentColumns, ...lineItemColumns],
        [attachmentColumns, lineItemColumns],
    );

    return usePageAiMeta(
        {
            path: '/quotes/:quote_id',
            title: t('quote', { ns: 'transaction-details' }),
            requires: ['canReadQuotes'],
            description:
                'One sales quote in full: customer, configuration, totals and logistics blocks and the ' +
                'line items. Some tenants also get a PDF Attachments tab with the documents the ERP ' +
                'printed for it. Send the user here for a question about a specific quote. The ' +
                'quote_id param is the ERP quote id. Some tenants do not have this page; if the user ' +
                'cannot see it, it is not enabled for them.',
        },
        columns,
    );
}

function QuotePage() {
    const navigate = useNavigate();
    const params = useParams<{ quote_id: string }>();
    const transactionId = params.quote_id || '';

    const goBack = () => {
        void navigate('/quotes', { replace: true });
    };

    return (
        <QuoteOrderDetailPage onBack={goBack} transactionId={transactionId} type={SrSalesOrderType.QUOTE} />
    );
}

export default QuotePage;
